import { observer } from 'mobx-react'
import { useLocation, useHistory } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'

import BlockComponentsRole75Checker from 'components/BlockComponentsRole75Checker'
import { useWinninAIReport } from 'contexts/WinninAIReportContext'
import { T, useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'
import { TOLGEE_GLOBALS, analyticsTracker } from 'utils'

import './index.scss'

function GenerateWinninAIReportButton({
  id,
  entity,
  providers = [],
  isDisabled = false,
  isDisabledMessage = '',
  analyticsTrackerPageTitle,
  zaiBtnConfig,
  onClick = null,
  title = '',
}) {
  const { addWinninAIReportItem } = useWinninAIReport()
  const isUserViewer = UserStore.getRole === 'viewer'
  const userPermissions = UserStore.userInfo?.permissions ?? []
  const doesUserHaveZaiBlocked = userPermissions.includes('no_create_zai_report')
  const t = useTranslate()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const history = useHistory()

  const handleClick = e => {
    e.preventDefault()
    e.stopPropagation()

    if (typeof onClick === 'function') {
      onClick()
      return
    }

    analyticsTracker.eventTrack(analyticsTracker.eventNames.AI_REPORT_CLICK, {
      title: analyticsTrackerPageTitle,
      id,
      entity,
    })

    searchParams.append('zaiReportEntityType', entity)
    searchParams.append('zaiReportEntityId', id)
    history.push({ search: searchParams.toString() })
    addWinninAIReportItem(id, entity, providers)
  }

  const isAccessBlocked = isUserViewer || doesUserHaveZaiBlocked

  return (
    <BlockComponentsRole75Checker
      isClickBlocked={isAccessBlocked || isDisabled}
      blockMessage={isAccessBlocked ? t(TOLGEE_GLOBALS.viewerBlockMessage) : isDisabledMessage}
    >
      <Button
        appearance={zaiBtnConfig?.appearance}
        icon="sparkle"
        variation={zaiBtnConfig?.variation}
        onClick={handleClick}
        iconSize={20}
        iconClassName={zaiBtnConfig?.iconClassName || 'GenerateWinninAIReportButton-icon'}
        disabled={isAccessBlocked || isDisabled}
      >
        <div className={zaiBtnConfig?.className}>
          {entity !== 'brand' ? (
            <T keyName={TOLGEE_GLOBALS.winninAIReport.key}>{TOLGEE_GLOBALS.winninAIReport.defaultValue}</T>
          ) : (
            title
          )}
        </div>
      </Button>
    </BlockComponentsRole75Checker>
  )
}

export default observer(GenerateWinninAIReportButton)
